module.exports = __webpack_public_path__ + "assets/a74b512d502fc1e39a86033d16f897b7.svg";